<template>
  <div style="overflow-y: auto">
    <div class="pl-1">
      <v-progress-linear
        indeterminate
        color="primary"
        class="pl-1"
        v-if="!fetched"
      ></v-progress-linear>
    </div>
    <span v-if="customers.length === 0 && fetched">
      <v-alert outlined color="primary" class="ma-1">
        {{ $t("common.no_data_available") }}
      </v-alert>
    </span>
    <v-simple-table v-else height="211">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t("common.date") }}
            </th>
            <th class="text-left">{{ $t("common.customer") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in customers.slice(0, limit)" :key="customer.id">
            <td>
              <span class="text-caption"
                >{{ customer.created_at | moment("DD.MM.YYYY") }}
                {{ customer.created_at | moment("HH:mm") }}</span
              >
            </td>
            <td>
              <span
                class="dashed"
                @click.stop="
                  customerWin.customerId = customer.id;
                  customerWin.isVisible = true;
                "
              >
                {{ customer.full_name }}
                {{
                  customer.is_company == 1
                    ? "[" + customer.legal_name + "]"
                    : ""
                }}
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="customerWin.isVisible" scrollable max-width="890">
      <customerForm
        @removed="customerWin.isVisible = false"
        :is-visible="customerWin.isVisible"
        :customer-id="customerWin.customerId"
        @update="getData()"
      ></customerForm>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CustomerForm from "@/components/customer/CustomerForm.vue";

export default {
  name: "MainWidgetCustomers",
  components: { CustomerForm },
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({
    customerWin: {
      customerId: null,
      isVisible: false,
    },
  }),
  computed: {
    ...mapFields("customers", ["customers", "fetched"]),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("customers/get");
    },
  },
};
</script>

<style scoped></style>
